import { __awaiter as f, __generator as c } from "./index11.js";
import { isOffline as h } from "./index13.js";
import { Context as l } from "./index14.js";
import { pWhile as m } from "./index63.js";
import { attempt as p } from "./index67.js";
function v(u, r) {
  return f(this, void 0, void 0, function() {
    var n, o = this;
    return c(this, function(s) {
      switch (s.label) {
        case 0:
          return n = [], h() ? [2, r] : [
            4,
            m(function() {
              return r.length > 0 && !h();
            }, function() {
              return f(o, void 0, void 0, function() {
                var t, i, e;
                return c(this, function(a) {
                  switch (a.label) {
                    case 0:
                      return t = r.pop(), t ? [4, p(t, u)] : [
                        2
                        /*return*/
                      ];
                    case 1:
                      return i = a.sent(), e = i instanceof l, e || n.push(t), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            })
            // re-add failed tasks
          ];
        case 1:
          return s.sent(), n.map(function(t) {
            return r.pushWithBackoff(t);
          }), [2, r];
      }
    });
  });
}
function x(u, r, n, o) {
  var s = this;
  u || setTimeout(function() {
    return f(s, void 0, void 0, function() {
      var t, i;
      return c(this, function(e) {
        switch (e.label) {
          case 0:
            return t = !0, [4, v(n, r)];
          case 1:
            return i = e.sent(), t = !1, r.todo > 0 && o(t, i, n, o), [
              2
              /*return*/
            ];
        }
      });
    });
  }, Math.random() * 5e3);
}
export {
  x as scheduleFlush
};
//# sourceMappingURL=index55.js.map
